import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import Preloader from "../Components/Common/Preloader";
import { metaTag } from "../Library/commomLib";
const RankingComponent = React.lazy(() => import("../Components/RootComponents/CTGRankingComponent"));
const CTGRankingPage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <RankingComponent />
      </Suspense>
    </Fragment>
  );
};

export default CTGRankingPage;
